import { createFileRoute } from '@tanstack/react-router'
import { UserPreferencesView } from '@workspace/seedforge-ui/user-preferences'
import { InvestorLayout } from '../../../../components/investor-layout'
import { useInvestorContext } from '../../../../contexts/investor-guard'
import { useUpdateUserMutation } from '../../../../hooks/api'

export const Route = createFileRoute('/app/investor/$id/preferences')({
  component: InvestorPreferencesPage,
})

function InvestorPreferencesPage() {
  const { user } = useInvestorContext()
  const updateUser = useUpdateUserMutation()

  return (
    <InvestorLayout activeNav="">
      <UserPreferencesView
        preferences={{ emailSubscribed: user.emailSubscribed }}
        widthClassName="max-w-3xl"
        onEmailSubscribedChange={(value) => updateUser.mutate({ body: { emailSubscribed: value } })}
      />
    </InvestorLayout>
  )
}
